<template>
<div class="px-md-10">
    <ValidationObserver ref="observer">
        <v-form>
            <v-row>
                <v-col cols="12" class="py-0">
                    <ValidationProvider v-slot="{ errors }" name="Email" rules="required|email">
                        <v-text-field cache-items @keyup.enter="loginClick" :disabled="status.isLoad" v-model="user.email" :error-messages="errors" label="Email" outlined dense required></v-text-field>
                    </ValidationProvider>
                </v-col>
                <v-col cols="12" class="py-0">
                    <ValidationProvider v-slot="{ errors }" name="Password" rules="required">
                        <v-text-field cache-items @keyup.enter="loginClick" label="Password" :disabled="status.isLoad" :append-icon="passwardShow ? 'mdi-eye' : 'mdi-eye-off'" outlined dense :type="passwardShow ? 'text' : 'password'" v-model="user.password" @click:append="passwardShow = !passwardShow" :error-messages="errors" required></v-text-field>
                    </ValidationProvider>
                </v-col>
                <v-col cols="12" class="pt-0 text-end">
                    <router-link class="anchor--text font-weight-bold" to="/forget-password">Forget password</router-link>
                </v-col>
            </v-row>
            <v-card-actions class="px-0 pb-6">
                <v-btn color="blue darken-1 px-4" block :loading="loading" dark @click="loginClick">Login</v-btn>
            </v-card-actions>
            <div>
                <v-divider class="mb-4"></v-divider>
                <p class="grey--text text-center">Don't have on account get? <router-link class="anchor--text font-weight-bold" to="/register">Sign up</router-link></p>
            </div><br>
        </v-form>
    </ValidationObserver>
</div>
</template>

<script>
import {
    mapGetters,
    mapActions,
    mapMutations
} from 'vuex'
import { required, email } from 'vee-validate/dist/rules'
import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
setInteractionMode('eager')
extend('required', {
    ...required,
    message: '{_field_} can not be empty',
})
extend('email', {
    ...email,
    message: 'Email must be valid',
})
export default {
    components: {
      ValidationProvider,
      ValidationObserver,
    },
    data: () => ({
        user: {
            email: '',
            password: ''
        },
        loading: false,
        valid: true,
        passwardShow: false,
        emailRules: [
            v => !!v || 'E-mail is required',
            v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        ],
        Rules: [
            v => !!v || 'Field is required',
        ],
    }),
    computed: {
        ...mapGetters(['status'])
    },
    methods: {
        ...mapActions(['login', 'GetUsage', 'PostResponse', 'GetResponse']),
        ...mapMutations(['getUsage', 'AlertErr', 'SnackbarSuccess', 'UserAccount', 'logIn', 'status_success', 'status_invalid']),
        loginClick() {
            this.$refs.observer.validate().then(async (res) => {
                if (res) {
                    this.loading = true
                    try {
                        let value = {
                            url: '/internal/v2/login',
                            data: this.user
                        }
                        const data = (await this.PostResponse(value)).data
                        if (data.success) {
                            this.loading = false
                            let msg = {
                                success : true,
                                message : "Welcome to OffersOptimize",
                                action : 'success'
                            }
                            this.SnackbarSuccess(msg)
                            localStorage.setItem("userToken", data.data.token);
                            localStorage.setItem("account", JSON.stringify(data.data.account))
                            localStorage.setItem("user", JSON.stringify(data.data.user))
                            localStorage.setItem("credit", JSON.stringify(data.data.credit))
                            this.UserAccount()
                            this.logIn()
                            this.$router.push(this.$route.query.redirect || '/')
                            this.$root.$emit('LogChange')
                        } else {
                            let msg = {
                                success: true,
                                message: data.message,
                                action: 'error'
                            }
                            this.SnackbarSuccess(msg)
                        }
                    } catch (error) {
                        this.user = {}
                        this.$refs.observer.reset()
                        let data = {
                            success : !error.response.data.success,
                            message : error.response.data.errors[0].message,
                            action : 'error'
                        }
                        this.SnackbarSuccess(data)
                        this.loading = false
                    }
                }
            })
        },
        Forgot() {
            this.$emit('forget')
        }
    },
    mounted() {
        this.$root.$on('resetValid', () => {
            this.user = {}
            this.$refs.observer.reset()
        })
    }

}
</script>
